export default "__VITE_ASSET__CcbkITKv__"